import * as axios from 'common/js/http'
import * as config from 'api/config'

export function getInvestorPersonal (data, au) {
  return axios.http(config.investorUrl + config.resUrl.investorPersonal, data, au)
}

export function getInvestorAgency (data, au) {
  return axios.http(config.investorUrl + config.resUrl.investorAgency, data, au)
}

export function getInvestorProduct (data, au) {
  return axios.http(config.investorUrl + config.resUrl.investorProduct, data, au)
}

export function getInvestorAuth (data, au) {
  return axios.http(config.investorUrl + config.resUrl.idAuth, data, au)
}

export function getInvestorOtherAuth (data, au) {
  return axios.http(config.investorUrl + config.resUrl.idAuthOther, data, au)
}

export function msgReady (data, au) {
  return axios.http(config.msgBaseUrl + config.resUrl.msgReady, data, au)
}



// WEBPACK FOOTER //
// ./src/api/investor.js